import { useCallback, useRef } from 'react';
import { Animated } from 'react-native';

function useController() {
  const shakeAnimation = useRef(new Animated.Value(0));

  const _animateButton = useCallback(() => {
    const commonProps = { duration: 100, useNativeDriver: true };
    Animated.timing(shakeAnimation.current).stop();
    Animated.sequence([
      Animated.timing(shakeAnimation.current, { toValue: 10, ...commonProps }),
      Animated.timing(shakeAnimation.current, { toValue: -10, ...commonProps }),
      Animated.timing(shakeAnimation.current, { toValue: 10, ...commonProps }),
      Animated.timing(shakeAnimation.current, { toValue: 0, ...commonProps }),
    ]).start();
  }, []);

  return {
    shakeAnimation: shakeAnimation.current,
    animateButton: _animateButton,
  };
}

export default useController;
